import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from '../../service/http.service';
@Injectable({
  providedIn: 'root'
})
export class SetupTourGuideService {

  constructor(private httpService: HttpService) { }
  
  getSetupTourGuide(params: any): Observable<any> {
    return this.httpService.get('setup-tour-guide', params);
  }
  saveSetupTourGuide(params: any): Observable<any> {
    return this.httpService.post('save-tour-guide', params);
  }
  getSetupTourGuideById(id:any,params: any): Observable<any> {
    return this.httpService.get('setup-tour-guide/'+id, params);
  }
}
